module.exports = __webpack_public_path__ + "assets/819bd30669b85021a3b9bad6225ff15b.mp3";